// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1z3BR","colMaxWidth":"Table_colMaxWidth__fBXMZ"};